import { render, staticRenderFns } from "./MinstmarcajeFormHeader.vue?vue&type=template&id=a960732a"
import script from "./MinstmarcajeFormHeader.vue?vue&type=script&lang=js"
export * from "./MinstmarcajeFormHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports